<nz-row nzGutter="16" class="dashboard-row">
  <nz-col nzXs="24" nzLg="10">
    <nz-card nzTitle="Vendor Overview" [nzBordered]="false" [nzBodyStyle]="{ height: '100%', display: 'flex' }">
      <nz-spin [nzSpinning]="summaryLoading" [nzTip]="'Loading summary...'" class="full-spin">
        <div *ngIf="chartHasData; else noChartData" class="payment-details-card">
          <div class="chart-wrap">
            <apx-chart [series]="pieSeries" [chart]="pieChart" [labels]="pieLabels" [legend]="pieLegend"
              [responsive]="pieResponsive" [tooltip]="pieTooltip" [stroke]="pieStroke" [colors]="pieColors"></apx-chart>
          </div>
          <div class="legend-wrap">
            <div style="width:100%; margin-bottom:8px; font-weight: 600; color:#555;">
              Total Paid (USD): <span>{{ totalPaidUSD | currency:'USD' }}</span>
            </div>
            <div class="legend-item" *ngFor="let item of pieLegendItems">
              <div class="legend-label">
                <span class="dot" [style.backgroundColor]="item.color"></span>
                <span style="font-size: smaller;">{{ item.label }}</span>
              </div>
              <span style="font-size: smaller;" class="value">{{ item.percentage }}%</span>
            </div>
          </div>
        </div>
        <!-- Single-line note placed below the graph and legend -->
        <div *ngIf="tinySlices.length" class="tiny-note-row">
          Note: Very small slices may not be clearly visible in the chart.
          <!-- <ng-container *ngFor="let t of tinySlices; let i = index">
            <span>{{ t }}</span><span *ngIf="i < tinySlices.length - 1">, </span>
          </ng-container> -->
        </div>
        <ng-template #noChartData>
          <div style="width: 100%; text-align: center; padding: 24px 0; color: rgba(0,0,0,.45);">No data is found</div>
        </ng-template>
      </nz-spin>
    </nz-card>
  </nz-col>

  <nz-col nzXs="24" nzLg="14">
    <nz-card nzTitle="Payments By Sourcing Types" [nzBordered]="false"
      [nzBodyStyle]="{ height: '100%', display: 'flex' }">
      <div class="card-table-wrap">
        <nz-table [nzData]="pagedVendorSummary" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="false"
          [nzNoResult]="'No data is found'">
          <thead>
            <tr>
              <th>Vendor</th>
              <th>Quotation</th>
              <th>Bill</th>
              <th>Paid</th>
              <th>Outstanding</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of pagedVendorSummary">
              <td>
                <a href="javascript:void(0)" (click)="selectVendor(v)" nz-tooltip [nzTooltipTitle]="v.vendor"
                  nzTooltipPlacement="right"
                  [ngClass]="vendorId === v.id ? 'ant-tag ant-tag-processing ng-star-inserted' : ''"
                  style="padding: 3px;">
                  <nz-avatar [nzText]="(v.vendor || '')[0]?.toUpperCase()"
                    [ngStyle]="{ 'background-color': v.avatarColor, 'color': '#ffffff' }"
                    style="margin-right:4px;width:24px;height:24px;line-height:24px;"></nz-avatar>
                  <strong>{{ v.vendor?.length > 25 ? (v.vendor | slice:0:25) + '...' : v.vendor }}</strong>
                  <i *ngIf="vendorId === v.id" nz-icon nzType="close" nzTheme="outline" style="margin-left:6px;"
                    (click)="clearVendorFilter($event)"></i>
                </a>
              </td>
              <td>{{ v.quotation_amount | currency:'USD' }}</td>
              <td>{{ v.total_bill | currency:'USD' }}</td>
              <td>{{ v.total_paid | currency:'USD' }}</td>
              <td [ngClass]="v.total_due > 0 ? 'due-positive' : (v.total_due < 0 ? 'due-negative' : '')">{{ v.total_due
                | currency:'USD' }}</td>
            </tr>
          </tbody>
        </nz-table>
        <!-- Manual pagination: < 1 2 3 4 > -->
        <div
          style="margin-top:8px; display:flex; gap:6px; align-items:center; flex-wrap: wrap; justify-content: flex-end; width: 100%;">
          <!-- Prev -->
          <button nz-button nzSize="small" (click)="prevVendorPage()"
            [disabled]="vendorTotalPages <= 1 || vendorPage === 1">&lt;</button>
          <!-- Page numbers (windowed) -->
          <button nz-button nzSize="small" *ngFor="let p of vendorPageWindow"
            [nzType]="vendorPage === p ? 'primary' : 'default'" (click)="goToVendorPage(p)">{{ p }}</button>
          <!-- Next -->
          <button nz-button nzSize="small" (click)="nextVendorPage()"
            [disabled]="vendorTotalPages <= 1 || vendorPage === vendorTotalPages">&gt;</button>
        </div>
      </div>
    </nz-card>
  </nz-col>
</nz-row>

<nz-row nzJustify="space-between" nzAlign="middle" style="margin-top: 24px; margin-bottom: 16px;">
  <nz-col>
    <h3 style="margin: 0;">Payment List</h3>
  </nz-col>
  <nz-col>
    <button nz-button nzType="primary" (click)="onAdd()">Add Payment</button>
  </nz-col>
</nz-row>

<nz-row style="margin-bottom: 16px;">
  <nz-col nzXs="24" nzSm="8">
    <input nz-input placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onSearch()" />
  </nz-col>
</nz-row>


<div class="card-table-wrap">
  <nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
    <nz-table class="payment-list-table" [nzData]="paymentList" [nzBordered]="true" [nzSize]="'middle'"
      [nzShowPagination]="false">
      <thead>
        <tr>
          <!-- <th>Payment ID</th> -->
          <th nzWidth="100px">Transaction ID</th>
          <th>Vendor</th>
          <th>Amount (USD)</th>
          <th>Paid Amount</th>
          <th>Payment Mode</th>
          <th>Paid On</th>
          <th>Status</th>
          <!-- <th>Reference</th> -->
          <!-- <th>Files</th> -->
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let payment of paymentList">
            <td (click)="openPaymentDetails(payment)"
              [ngClass]="{ 'payment-id-cell-disabled': !hasTransactionId(payment?.transaction_id) }"
              [style.cursor]="hasTransactionId(payment?.transaction_id) ? 'pointer' : 'default'" style="font-weight: 600;">
            <a href="javascript:void(0)" class="payment-id-link"
              [ngClass]="{ 'payment-id-link-disabled': !hasTransactionId(payment?.transaction_id) }">
                <nz-tag [nzColor]="hasTransactionId(payment?.transaction_id) ? 'geekblue' : 'default'" nz-tooltip
                  [nzTooltipTitle]="hasTransactionId(payment?.transaction_id) ? payment.transaction_id : null"
                  [ngClass]="{ 'payment-id-tag-disabled': !hasTransactionId(payment?.transaction_id) }">
                  {{ hasTransactionId(payment?.transaction_id)
                  ? ((payment.transaction_id?.length > 5) ? (payment.transaction_id | uppercase | slice:0:8) + '...' :
                  (payment.transaction_id | uppercase))
                  : 'NA' }}
              </nz-tag>
            </a>
          </td>
          <td>
            <a href="javascript:void(0)" (click)="onVendorDetails(payment?.vendor_details?.id)" nz-tooltip
              [nzTooltipTitle]="payment?.vendor_details?.name" nzTooltipPlacement="right">
              <nz-avatar [nzText]="(payment?.vendor_details?.name || '')[0]?.toUpperCase()"
                [ngStyle]="{ 'background-color': getAvatarColor(payment?.vendor_details?.name), 'color': '#ffffff' }"
                style="margin-right:4px;width:24px;height:24px;line-height:24px;"></nz-avatar>
              <strong>{{ payment?.vendor_details?.name | titlecase }}</strong>
            </a>
          </td>
          <td>
            {{ payment.amount_paid_usd | currency:'USD' }}
            <!-- <span *ngIf="payment.usd_currency_exchange_rate"> ({{ payment.usd_currency_exchange_rate | number:'1.0-6'
              }})</span> -->
          </td>
          <td>
            <ng-container *ngIf="payment.amount_paid_selected_currency != null; else dash">
              {{ payment.amount_paid_selected_currency | currency:(payment.paid_currency_name?.symbol ||
              'USD'):'symbol':'1.2-2' }}
            </ng-container>
            <ng-template #dash>-</ng-template>
          </td>
          <td>{{ payment.payment_method }}</td>
          <td>{{ payment.payment_date | date: 'mediumDate' }}</td>
          <td>
            <nz-tag [nzColor]="
              payment.status === 'Completed'
                ? 'green'
                : payment.status === 'Pending'
                ? 'orange'
                : 'red'
            ">
              {{ payment.status }}
            </nz-tag>
          </td>
          <!-- <td>{{ payment.notes }}</td> -->
          <!-- <td class="files-cell">
            <span *ngFor="let file of payment?.file_details; let i = index">
              <a [href]="getFileDownloadLink(file.file_url)" download target="_blank">{{getFileName(file.file_url)}}</a>
              <span *ngIf="i < payment?.file_details.length - 1">, </span>
            </span>
          </td> -->
          <td class="actions-cell">
            <button nz-button nzType="default" nzSize="small" (click)="editPayment(payment)" >
              <!-- <nz-icon nzType="edit" nzTheme="outline"
                (click)="editPayment(payment)" /> -->
                  <nz-icon nzType="edit" nzTheme="outline"
                />
            </button>
            <button nz-button nzType="default" nzDanger style="margin-left: 10px;" nzSize="small"
              class="custom-popconfirm" [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
              [nzPopconfirmTitle]="popconfirmTpl" nz-popconfirm nzPopconfirmTitle="Are you sure delete this payment?"
              nzPopconfirmPlacement="bottom" (nzOnConfirm)="deletePayment(payment.id)">
              <nz-icon nzType="delete" nzTheme="outline" />
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</div>

<ng-template #popconfirmTpl let-popconfirm="popconfirm">
  <div class="custom-popconfirm-header">
    <span class="custom-popconfirm-title">
      Confirm Deletion
    </span>
  </div>
  <div class="custom-popconfirm-icon-area">
    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
    </span>
  </div>
  <div class="custom-popconfirm-message description">
    Are you sure you want to delete this item?<br />
    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
  </div>
</ng-template>